const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  // BILLS
  GET_BILLS_SUCCESS: "BILLS/GET_BILLS_SUCCESS",
  GET_BILLS_BEGINS: "BILLS/GET_BILLS_BEGINS",
  GET_BILLS_FAILURE: "BILLS/GET_BILLS_FAILURE",
  /* BILL DETAILS */
  GET_BILL_DETAILS_BEGINS: "BILLS/GET_BILL_DETAILS_BEGINS",
  GET_BILL_DETAILS_SUCCESS: "BILLS/GET_BILL_DETAILS_SUCCESS",
  GET_BILL_DETAILS_FAILURE: "BILLS/GET_BILL_DETAILS_FAILURE",
  /* BILL ADDRESS */
  GET_BILL_ADDRESS_BEGINS: "BILLS/GET_BILL_ADDRESS_BEGINS",
  GET_BILL_ADDRESS_SUCCESS: "BILLS/GET_BILL_ADDRESS_SUCCESS",
  GET_BILL_ADDRESS_FAILURE: "BILLS/GET_BILL_ADDRESS_FAILURE",
  /* BILL DUPLICATE */
  POST_BILL_DUPLICATE_RESET: "BILLS/POST_BILL_DUPLICATE_RESET",
  POST_BILL_DUPLICATE_BEGINS: "BILLS/POST_BILL_DUPLICATE_BEGINS",
  POST_BILL_DUPLICATE_SUCCESS: "BILLS/POST_BILL_DUPLICATE_SUCCESS",
  POST_BILL_DUPLICATE_FAILURE: "BILLS/POST_BILL_DUPLICATE_FAILURE",
  /* DOWNLOAD BILLS */
  GET_BILL_DOWNLOAD_BEGINS: "GET_BILL_DOWNLOAD_BEGINS",
  GET_BILL_DOWNLOAD_SUCCESS: "GET_BILL_DOWNLOAD_SUCCESS",
  GET_BILL_DOWNLOAD_FAILURE: "GET_BILL_DOWNLOAD_FAILURE",
  // ECOBILL
  POST_ECO_BILL_BEGIN: "BILLS/POST_ECO_BILL_BEGIN",
  POST_ECO_BILL_SUCCESS: "BILLS/POST_ECO_BILL_SUCCESS",
  POST_ECO_BILL_FAILURE: "BILLS/POST_ECO_BILL_FAILURE",
  RESET_ECO_BILL: "RESET_ECO_BILL",
  SET_ECO_BILL: "SET_ECO_BILL",
  SET_EMAIL: "SET_EMAIL",
  SET_AVAILABLE_NOTIFICATION: "SET_AVAILABLE_NOTIFICATION",
  // BILL DATE
  GET_BILLING_DATE_SUCCESS: "GET_BILLING_DATE_SUCCESS",
  GET_BILLING_DATE_BEGINS: "GET_BILLING_DATE_BEGINS",
  GET_BILLING_DATE_FAILURE: "GET_BILLING_DATE_FAILURE",
  // BILLS CLAIMS
  GET_BILLS_CLAIMS_BEGINS: "GET_BILLS_CLAIMS_BEGINS",
  GET_BILLS_CLAIMS_SUCCESS: "GET_BILLS_CLAIMS_SUCCESS",
  GET_BILLS_CLAIMS_FAILURE: "GET_BILLS_CLAIMS_FAILURE",
  GET_BILLS_CLAIMS_DETAILS_BEGINS: "GET_BILLS_CLAIMS_DETAILS_BEGINS",
  GET_BILLS_CLAIMS_DETAILS_SUCCESS: "GET_BILLS_CLAIMS_DETAILS_SUCCESS",
  GET_BILLS_CLAIMS_DETAILS_FAILURE: "GET_BILLS_CLAIMS_DETAILS_FAILURE",
  //FILTERS
  SET_FILTERS: "SET_FILTERS",
  SET_FILTERS_BILLS: "SET_FILTERS_BILLS",
  SET_PERIOD_FILTER: "SET_PERIOD_FILTER",
  // MODIFY BILL ADDRESS
  MODIFY_BILL_ADDRESS_BEGIN: 'MODIFY_BILL_ADDRESS_BEGIN',
  MODIFY_BILL_ADDRESS_SUCCESS: 'MODIFY_BILL_ADDRESS_SUCCESS',
  MODIFY_BILL_ADDRESS_FAILURE: 'MODIFY_BILL_ADDRESS_FAILURE',
  RESET_MODIFY_BILL_ADDRESS: 'RESET_MODIFY_BILL_ADDRESS',
  // CLAIM DETAILS
  GET_CLAIM_DETAILS: "GET_CLAIM_DETAILS",
  SET_CLAIM_DETAILS: "SET_CLAIM_DETAILS",
  SET_OPEN_CLAIM: "SET_OPEN_CLAIM",

  RESET_BILLS: 'RESET_BILLS',
};

export const actions = {
  // Actions for bills
  getMyBills: (months) => ({ type: types.GET_BILLS_BEGINS, months }),
  successGetBillData: (data) => ({
    type: types.GET_BILLS_SUCCESS,
    payload: data,
  }),
  failureGetBillData: (error) => ({
    type: types.GET_BILLS_FAILURE,
    payload: error,
  }),
  /* Actions for billsDetails */
  getBillDetails: (params) => ({
    type: types.GET_BILL_DETAILS_BEGINS,
    payload: params,
  }),
  successGetBillDetails: (data) => ({
    type: types.GET_BILL_DETAILS_SUCCESS,
    payload: data,
  }),
  failureGetBillDetails: (error) => ({
    type: types.GET_BILL_DETAILS_FAILURE,
    payload: error,
  }),
  /* Actions for billsAddress */
  getBillAddress: (id) => ({
    type: types.GET_BILL_ADDRESS_BEGINS,
    payload: id,
  }),
  successGetBillAddress: (data) => ({
    type: types.GET_BILL_ADDRESS_SUCCESS,
    payload: data,
  }),
  failureGetBillAddress: (error) => ({
    type: types.GET_BILL_ADDRESS_FAILURE,
    payload: error,
  }),
  /* Actions for billDuplicate */
  resetBillDuplicate: () => ({ type: types.POST_BILL_DUPLICATE_RESET }),
  postBillDuplicate: (id) => ({
    type: types.POST_BILL_DUPLICATE_BEGINS,
    payload: id,
  }),
  successPostBillDuplicate: (data) => ({
    type: types.POST_BILL_DUPLICATE_SUCCESS,
    payload: data,
  }),
  failurePostBillDuplicate: (error) => ({
    type: types.POST_BILL_DUPLICATE_FAILURE,
    payload: error,
  }),
  /* Actions for download bill */
  getBillDownload: (params) => ({
    type: types.GET_BILL_DOWNLOAD_BEGINS,
    payload: params,
  }),
  successGetBillDownload: (response, idBill) => ({
    type: types.GET_BILL_DOWNLOAD_SUCCESS,
    payload: { response, idBill },
  }),
  failureGetBillDownload: (error) => ({
    type: types.GET_BILL_DOWNLOAD_FAILURE,
    payload: error,
  }),
  /* Actions for ecoBill */
  postEcoBill: (params) => ({
    type: types.POST_ECO_BILL_BEGIN,
    payload: params,
  }),
  successPostEcoBill: (data) => ({
    type: types.POST_ECO_BILL_SUCCESS,
    payload: data,
  }),
  failurePostEcoBill: (error) => ({
    type: types.POST_ECO_BILL_FAILURE,
    payload: error,
  }),
  resetEcoBill: () => ({ type: types.RESET_ECO_BILL }),
  setEcoBill: (ecoBill) => ({ type: types.SET_ECO_BILL, payload: ecoBill }),
  setEmail: (email) => ({ type: types.SET_EMAIL, payload: email }),
  setAvailableNotification: (availableNotification) => ({
    type: types.SET_AVAILABLE_NOTIFICATION,
    payload: availableNotification,
  }),
  getBillingDate: (accountId) => ({
    type: types.GET_BILLING_DATE_BEGINS,
    accountId,
  }),
  successGetBillingDate: (data) => ({
    type: types.GET_BILLING_DATE_SUCCESS,
    payload: data,
  }),
  failureGetBillingDate: () => ({
    type: types.GET_BILLING_DATE_FAILURE,
  }),
  /* Actions for billsClaims */
  getBillsClaimsData: (params) => ({
    type: types.GET_BILLS_CLAIMS_BEGINS,
    payload: params,
  }),
  successGetBillsClaimsData: (data, billsClaimsCards) => ({
    type: types.GET_BILLS_CLAIMS_SUCCESS,
    payload: {data, billsClaimsCards},
  }),
  failureGetBillsClaimsData: (error) => ({
    type: types.GET_BILLS_CLAIMS_FAILURE,
    payload: error,
  }),
  /* Filters */
  setFilters: (filter) => ({
    type: types.SET_FILTERS,
    payload: filter,
  }),
  setFilterBills: (bills) => ({
    type: types.SET_FILTERS_BILLS,
    payload: bills,
  }),
  setPeriodFilter: (period) => ({
    type: types.SET_PERIOD_FILTER,
    payload: period,
  }),
  /* Actions for modifyBillAddress */
  resetModifyBillAddress: () => ({ type: types.RESET_MODIFY_BILL_ADDRESS }),
  modifyBillAddress: (id) => ({
    type: types.MODIFY_BILL_ADDRESS_BEGIN,
    payload: id,
  }),
  successModifyBillAddress: (data) => ({
    type: types.MODIFY_BILL_ADDRESS_SUCCESS,
    payload: data,
  }),
  failureModifyBillAddress: (error) => ({
    type: types.MODIFY_BILL_ADDRESS_FAILURE,
    payload: error,
  }),
  // Claim details
  getClaimDetails: (billId, code) => ({
    type: types.GET_CLAIM_DETAILS,
    billId,
    code
  }),
  setClaimDetails: ({ data, id, detailError }) => ({
    type: types.SET_CLAIM_DETAILS,
    payload: { data, id, detailError }
  }),
  setOpenClaim: (id) => ({
    type: types.SET_OPEN_CLAIM,
    payload: {id}
  }),
  resetBills: () => ({ type: types.RESET_BILLS }),
};

const initialState = {
  bills: {},
  billsError: null,
  billsFetching: false,
  billsAlreadyFetched: false,
  selectedMonth: null,
  billDetailsInfo: {},
  billDetailsError: null,
  billDetailsFetching: false,
  billDuplicate: {},
  billDuplicateError: null,
  billDuplicateFetching: false,
  totalBillsByMonth: [],
  iframeBillsError: null,
  billAdress: {},
  billAdressError: null,
  billAdressFetching: null,
  ecoBill: false,
  email: null,
  ecoBillInfo: null,
  ecoBillFetching: false,
  ecoBillFailure: false,
  availableNotification: null,
  billingDate: {},
  billingDateError: false,
  billingDateFetching: false,
  billsClaims: [],
  billsClaimsCards: null,
  billsClaimsError: null,
  billsClaimsFetching: false,
  billsClaimsAlreadyFetched: false,
  billsClaimsDetails: [],
  billsClaimsDetailsError: null,
  billsClaimsDetailsFetching: false,
  billDownload: null,
  billDownloadFetching: false,
  billDownloadError: null,
  modifyBillAddress: null,
  modifyBillAddressFetching: null,
  modifyBillAddressError: null,
  billsFilter: [],
  filteredBills: null,
  periodSelected: null,
  claimsDetails: {},
  claimsFetching: null,
  claimDetailError: null,
  openClaim: null,
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { bills } = payload;
      return {
        ...state,
        ...bills,
      };
    }
    case types.GET_BILLS_BEGINS: {
      return {
        ...state,
        billsFetching: true,
        billsError: null,
      };
    }
    case types.GET_BILLS_SUCCESS: {
      const data = payload;
      return {
        ...state,
        bills: data.bills,
        billsList: data.billsList,
        totalBillsByMonth: data.totalBillsByMonth,
        ecoBill: data.ecoBill,
        availableNotification: data.availableNotification,
        email: data.email,
        billsFetching: false,
        billsAlreadyFetched: true,
        billsError: false,
      };
    }
    case types.GET_BILLS_FAILURE:
      return { ...state, billsError: payload, billsFetching: false };
    case types.GET_BILL_DETAILS_BEGINS:
      return { ...state, billDetailsFetching: true, billDetailsError: null };
    case types.GET_BILL_DETAILS_SUCCESS: {
      const newBillDetails = payload;
      const { billNo } = newBillDetails;
      const newBillDetailsStructure = {
        ...state.billDetailsInfo,
      };
      newBillDetailsStructure[billNo] = newBillDetails;
      return {
        ...state,
        billDetailsError: null,
        billDetailsFetching: false,
        billDetailsInfo: newBillDetailsStructure,
      };
    }
    case types.GET_BILL_DETAILS_FAILURE:
      return {
        ...state,
        billDetailsError: payload,
        billDetailsFetching: false,
      };
    case types.POST_BILL_DUPLICATE_RESET:
      return {
        ...state,
        billDuplicate: {},
        billDuplicateError: null,
        billDuplicateFetching: false,
      };
    case types.POST_BILL_DUPLICATE_BEGINS:
      return {
        ...state,
        billDuplicate: {},
        billDuplicateError: null,
        billDuplicateFetching: true,
      };
    case types.POST_BILL_DUPLICATE_SUCCESS:
      return {
        ...state,
        billDuplicate: payload,
        billDuplicateError: null,
        billDuplicateFetching: false,
      };
    case types.POST_BILL_DUPLICATE_FAILURE: {
      const objError = payload;
      return {
        ...state,
        billDuplicate: {},
        billDuplicateError: objError,
        billDuplicateFetching: false,
      };
    }
    case types.GET_BILL_ADDRESS_BEGINS:
      return {
        ...state,
        billAddress: {},
        billAddressError: null,
        billAddressFetching: true,
      };
    case types.GET_BILL_ADDRESS_SUCCESS: {
      return {
        ...state,
        billAddress: payload,
        billAddressError: null,
        billAddressFetching: false,
      };
    }
    case types.GET_BILL_ADDRESS_FAILURE: {
      return {
        ...state,
        billAddress: {},
        billAddressError: true,
        billAddressFetching: false,
      };
    }
    case types.GET_BILL_DOWNLOAD_BEGINS:
      return {
        ...state,
        billDownloadFetching: true,
        billDownloadError: null,
      };
    case types.GET_BILL_DOWNLOAD_SUCCESS: {
      const { response, idBill } = payload;

      const lastDataBillDownload = {
        ...state.billDownload,
      };
      const lastKeys = Object.keys(lastDataBillDownload);
      const exist = lastKeys.find((elem) => elem === idBill);
      if (!exist) {
        lastDataBillDownload[idBill] = response;
      }

      return {
        ...state,
        billDownload: lastDataBillDownload,
        billDownloadFetching: false,
        billDownloadError: null,
      };
    }
    case types.GET_BILL_DOWNLOAD_FAILURE: {
      return {
        ...state,
        billDownload: null,
        billDownloadFetching: false,
        billDownloadError: true,
      };
    }
    case types.POST_ECO_BILL_BEGIN:
      return {
        ...state,
        ecoBillInfo: null,
        ecoBillFetching: true,
        ecoBillFailure: null,
      };
    case types.POST_ECO_BILL_SUCCESS: {
      return {
        ...state,
        ecoBillInfo: payload,
        ecoBillFetching: false,
        ecoBillFailure: null,
      };
    }
    case types.POST_ECO_BILL_FAILURE: {
      return {
        ...state,
        ecoBillInfo: null,
        ecoBillFetching: false,
        ecoBillFailure: true,
      };
    }
    case types.RESET_ECO_BILL: {
      return {
        ...state,
        ecoBillInfo: null,
        ecoBillFetching: false,
        ecoBillFailure: null,
      };
    }
    case types.SET_ECO_BILL: {
      const ecoBill = payload;
      return {
        ...state,
        ecoBill,
      };
    }
    case types.SET_EMAIL: {
      const email = payload;
      return {
        ...state,
        email,
      };
    }
    case types.SET_AVAILABLE_NOTIFICATION: {
      const availableNotification = payload;
      return {
        ...state,
        availableNotification,
      };
    }
    case types.GET_BILLING_DATE_BEGINS:
      return {
        ...state,
        billingDateFetching: true,
        billingDateError: false,
      };
    case types.GET_BILLING_DATE_SUCCESS: {
      let newBillingDate = state.billingDate;
      if (payload) {
        newBillingDate = { ...state.billingDate, [payload.accountId]: payload };
      }
      return {
        ...state,
        billingDate: newBillingDate,
        billingDateError: false,
        billingDateFetching: false,
      };
    }
    case types.GET_BILLING_DATE_FAILURE:
      return {
        ...state,
        billingDateFetching: false,
        billingDateError: true,
      };
    case types.GET_BILLS_CLAIMS_BEGINS:
      return {
        ...state,
        billsClaimsFetching: true,
        billsClaimsError: false,
      };
    case types.GET_BILLS_CLAIMS_SUCCESS: {
      let { billsClaims } = state;
      const { data, billsClaimsCards } = payload;
      if (data && data.facturasReclamaciones) {
        billsClaims = data.facturasReclamaciones;
      } else if (data) {
        billsClaims = data;
      }
      return {
        ...state,
        billsClaims,
        billsClaimsCards: billsClaimsCards,
        billsClaimsError: false,
        billsClaimsFetching: false,
        billsClaimsAlreadyFetched: true,
      };
    }
    case types.GET_BILLS_CLAIMS_FAILURE:
      return {
        ...state,
        billsClaimsFetching: false,
        billsClaimsError: payload,
      };
    case types.GET_BILLS_CLAIMS_DETAILS_BEGINS:
      return {
        ...state,
        billsClaimsDetailsFetching: true,
        billsClaimsDetailsError: false,
      };
    case types.GET_BILLS_CLAIMS_DETAILS_SUCCESS: {
      return {
        ...state,
        billsClaimsDetails: payload,
        billsClaimsDetailsFetching: false,
        billsClaimsDetailsError: null,
      };
    }
    case types.GET_BILLS_CLAIMS_DETAILS_FAILURE:
      return {
        ...state,
        billsClaimsDetailsFetching: false,
        billsClaimsDetailsError: true,
      };
    case types.SET_FILTERS:
      return {
        ...state,
        billsFilter: payload,
      };
    case types.SET_FILTERS_BILLS:
      return {
        ...state,
        filteredBills: payload,
      };
    case types.SET_PERIOD_FILTER:
      return {
        ...state,
        periodSelected: payload,
      };
    case types.RESET_MODIFY_BILL_ADDRESS:
      return {
        ...state,
        modifyBillAddress: null,
        modifyBillAddressFetching: false,
        modifyBillAddressError: null,
      };
    case types.MODIFY_BILL_ADDRESS_BEGIN:
      return {
        ...state,
        modifyBillAddress: null,
        modifyBillAddressFetching: true,
        modifyBillAddressError: null,
      };
    case types.MODIFY_BILL_ADDRESS_SUCCESS:
      return {
        ...state,
        modifyBillAddress: payload,
        modifyBillAddressFetching: false,
        modifyBillAddressError: null,
      };
    case types.MODIFY_BILL_ADDRESS_FAILURE: {
      const objError = payload;
      return {
        ...state,
        modifyBillAddress: null,
        modifyBillAddressFetching: false,
        modifyBillAddressError: true,
      };
    }
    // CLAIMS DETAILS
    case types.GET_CLAIM_DETAILS: {
      return {
        ...state,
        claimsFetching: true,
        claimDetailError: null,
      }
    }
    case types.SET_CLAIM_DETAILS: {
      const { id, detailError } = payload; 
      let { claimsDetails } = state;

      if (detailError) {
        return {
          ...state,
          claimsFetching: false,
          claimDetailError: detailError,
        };
      }

      if (!claimsDetails?.[id]) {
         return {
          ...state,
          claimsDetails: {
            ...claimsDetails,
            [id]: payload?.data,
          },
          claimsFetching: false,
          claimDetailError: null,
        };
      }


      return {
        ...state,
        claimsFetching: false,
        claimDetailError: null,
      };
    }
    case types.SET_OPEN_CLAIM: {
      return {
        ...state,
        openClaim: payload?.id,
        claimDetailError: null,
      };
    }
    case types.RESET_BILLS: {
      return {
        ...state,
        bills: {},
        totalBillsByMonth: [],
        ecoBill: false,
        availableNotification: null,
        email: null,
        billsFetching: false,
        billsAlreadyFetched: false,
      }
    }
    default:
      return state;
  }
}

export default reducer;
